import { Component, OnInit, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { Client } from '../models/clientLocation';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ClientService } from '../services/client.service';
import { ToastrService } from 'ngx-toastr';
import { ValidationService } from '../../services/validation.service';
import { ObjectUpdatePayload } from '../../models/screeningInvite';
import { PhonePipe } from '../../pipes/phone.pipe';
import { Address } from '../../models/Address';
import { UntypedFormGroup, NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RiqAlertComponent } from 'src/app/shared-components-module/riq-alert/riq-alert.component';

@Component({
  selector: 'app-clients-edit',
  templateUrl: './clients-edit.component.html',
  styleUrls: ['./clients-edit.component.less']
})
export class ClientsEditComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('form',{}) ngForm: NgForm;
  isLinear = false;
  addressesSame : boolean = true;
  generalInfo: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;
  clientAccountTypes : any[] = [{name:"Tenant", id:1},{name :'Employment', id: 2}] // Id corresponds to enum values in client.cs
  clientBillingTypes : any[] = [{name:"Invoicing", id:1},{name :'Point Of Sale', id: 0}] // Id corresponds to enum values in client.cs  
  debtDecisions : any[] = [{name: "Ignore", id: 2}, {name: "Review Required", id: 1}, {name: "Decline", id: 0}];
  model : Client = new Client();
  constructor(public phone : PhonePipe,public validator : ValidationService,public auth : AuthService, public location : Router,public activatedRoute: ActivatedRoute, public clients : ClientService, public toastr: ToastrService,
    public modalService: NgbModal){
    
    
  }
  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    this.ngForm.resetForm('');
  }

  ngOnInit() {


 
    this.activatedRoute.paramMap.subscribe((p : ParamMap) => {
      let clientId = parseInt(p.get('id'));

      this.clients.GetClientById(clientId).subscribe((rslt : Client) =>{
        this.model = Object.assign(new Client(),rslt );
      })
    })
  }

  setAccountType(s: any) {
    this.model.accountType = s.id;
  }
    
  saveAndContinue(){
    if(this.ngForm.valid) {
      this.clients.UpdateClientSingle(this.model).subscribe(  
        (dta: boolean)=>{
          if(dta){
            this.toastr.success('Client updated successfully.', 'Update Succeeded!')
          }else{
            this.toastr.error('Client update failed.', 'Update Failed!', { disableTimeOut: true, closeButton: true})
          }
      },
      (err: any)=>{
          this.toastr.error('Client update failed.', 'Update Failed!', { disableTimeOut: true, closeButton: true})
      })
      // If any addresses have been added to the client then save them also.
      let newAddys = this.model.addresses.filter(a => {return a.id == 0 || !a.id; })
      if(newAddys.length > 0) {
        this.clients.AddClientAddress(newAddys[0]).subscribe(e => {
          newAddys[0].id = e;
        });
      }
    }
  }

  fireClientUpdates(){
   
  }

  handleClientDeactivation() {
    //if a user is turning this on, no issues with just binding that up and letting the user save/continue
    if(!this.model.isActive) {
      this.model.isActive = true;
      return;
    }
    else {
      //we need to pop some alerts and call a special route
      //RIQ-3018: pop a RIQ alert modal to warn user that this action applies to all underlying properties
      const modalRef = this.modalService.open(RiqAlertComponent, { centered: true, size: 'lg' });
      modalRef.componentInstance.name = 'ClientDeactivate';
      modalRef.componentInstance.title = "Deactivate Client";
      modalRef.componentInstance.confirmButtonText = "Yes, I'm sure";
      modalRef.componentInstance.cancelButtonText = "Cancel";
      modalRef.componentInstance.alertBody = `Deactivating the client will deactivate ALL PROPERTIES belonging to ${this.model.clientName}. If you want to change a single property, please go to the Properties page. Are you sure you want to deactivate ALL PROPERTIES of ${this.model.clientName}?`;
      // modalRef.componentInstance.shown.subscribe((ev: any)=>{
        modalRef.componentInstance.evnt.subscribe((ev:boolean)=>{
          
          this.clients.DeactivateClient(this.model.id).subscribe(
            (dta: boolean)=>{
              this.toastr.success('Client deactivated successfully.', 'Update Succeeded!');
              this.model.isActive = false;
              modalRef.dismiss();
              this.cancelAddClient(); //nav back to the home screen, save a click
          },
          (err: any)=>{
            this.toastr.error('Client deactivation failed.', 'Update Failed!', { disableTimeOut: true, closeButton: true});
          })
        });
    }
  }

  cancelAddClient(){
    //reset form state so we don't persist validation errors
    this.ngForm.resetForm('');
    this.location.navigateByUrl("/clients");
  }
}
